<template>
  <div class="mt-2">
    <Loading v-if="loadingState" />
    <template v-else>
      <span v-if="bookKeppList.length > 0">
        <b-row
          v-for="(bookkeep, index) in bookKeppList"
          :key="index"
          class=""
        >
          <b-col
            xl="4"
            sm="6"
            class="py-1 position-relative"
          >
            <v-select
              v-model="bookkeep.criteriaValue"
              :clearable="false"
              :options="criteria"
              label="label"
              :placeholder="$t('SettingPageCard.placeHolder.chooseCriteria')"
              class="per-page-selector-criteria d-inline-block"
              @input="validationComparison('criteria_field', bookkeep)"
            />
            <template v-if="textHelper.length > 0">
              <feather-icon
                v-show="index == bookKeppList.length - 1"
                v-b-tooltip.hover.v-primary
                size="16"
                :title="renderMarkIcon('bookkeep_criteria_field')"
                icon="HelpCircleIcon"
                class="ml-50 position-absolute"
                style="top: 0"
              />
            </template>
          </b-col>
          <!-- This is Comparison -->
          <b-col
            xl="3"
            sm="6"
            class="py-1 position-relative"
          >
            <v-select
              v-model="bookkeep.comparisonValue"
              :clearable="false"
              :options="comparisonList(bookkeep.criteriaValue)"
              :placeholder="$t('SettingPageCard.placeHolder.equals')"
              class="per-page-selector d-inline-block"
              @input="validationComparison('comparison', bookkeep)"
            />
          </b-col>

          <b-col
            xl="3"
            sm="6"
            class="py-1"
            style="z-index: 0"
          >
            <b-form-group>
              <b-form-input
                v-model="bookkeep.criteria_value"
                :placeholder="$t('SettingPageCard.placeHolder.inputCriteria')"
                @input="editBookeep('criteria_value', bookkeep)"
              />
              <template v-if="textHelper.length > 0">
                <feather-icon
                  v-show="index == bookKeppList.length - 1"
                  v-b-tooltip.hover.v-primary
                  size="16"
                  :title="renderMarkIcon('bookkeep_criteria_value')"
                  icon="HelpCircleIcon"
                  class="ml-50 position-absolute"
                  style="top: -2px; right: 0; z-index: 99"
                />
              </template>
            </b-form-group>
          </b-col>

          <b-col
            xl="2"
            sm="6"
            class="py-1"
          >
            <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              variant="danger"
              class="btn-icon mr-1"
              @click="removeBookeep(index, bookkeep.uuid)"
            >
              <feather-icon icon="XIcon" />
            </b-button>
            <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              variant="warning"
              class="btn-icon"
              @click="addNewBookkeep(bookkeep)"
            >
              <feather-icon icon="PlusIcon" />
            </b-button>
          </b-col>
        </b-row>
      </span>

      <ValidationObserver
        v-else-if="(!hideWhenEmpty || showEmptyForm) && enabled"
        ref="form"
      >
        <b-row class="">
          <b-col
            xl="4"
            sm="6"
            class="py-1 position-relative"
          >
            <ValidationProvider
              #default="{ errors }"
              rules="required"
              :name="$t('SettingPageCard.placeHolder.chooseCriteria')"
            >
              <v-select
                v-model="newBookkeep.criteriaValue"
                :clearable="false"
                :options="criteria"
                label="label"
                :placeholder="$t('SettingPageCard.placeHolder.chooseCriteria')"
                class="per-page-selector-criteria d-inline-block"
                @input="validationComparison('criteria_field', newBookkeep)"
              />
              <template v-if="textHelper.length > 0">
                <feather-icon
                  v-b-tooltip.hover.v-primary
                  size="16"
                  :title="renderMarkIcon('bookkeep_criteria_field')"
                  icon="HelpCircleIcon"
                  class="ml-50 position-absolute"
                  style="top: 0"
                />
              </template>
              <small class="text-danger">
                {{ errors[0] }}
              </small>
            </ValidationProvider>
          </b-col>
          <!-- This is Comparison -->
          <b-col
            xl="3"
            sm="6"
            class="py-1 position-relative"
          >
            <ValidationProvider
              #default="{ errors }"
              rules="required"
              :name="$t('SettingPageCard.placeHolder.equals')"
            >
              <v-select
                v-model="newBookkeep.comparisonValue"
                :clearable="false"
                :options="comparisonList(newBookkeep.criteriaValue)"
                :placeholder="$t('SettingPageCard.placeHolder.equals')"
                class="per-page-selector d-inline-block"
                @input="validationComparison('comparison', newBookkeep)"
              />

              <small class="text-danger">
                {{ errors[0] }}
              </small>
            </ValidationProvider>
          </b-col>

          <b-col
            xl="3"
            sm="6"
            class="py-1"
            style="z-index: 0"
          >
            <b-form-group>
              <ValidationProvider
                #default="{ errors }"
                rules="required"
                :name="$t('SettingPageCard.placeHolder.inputCriteria')"
              >
                <b-form-input
                  v-model="newBookkeep.criteria_value"
                  :placeholder="$t('SettingPageCard.placeHolder.inputCriteria')"
                  @input="editBookeep('criteria_value', newBookkeep)"
                />
                <template v-if="textHelper.length > 0">
                  <feather-icon
                    v-b-tooltip.hover.v-primary
                    size="16"
                    :title="renderMarkIcon('bookkeep_criteria_value')"
                    icon="HelpCircleIcon"
                    class="ml-50 position-absolute"
                    style="top: -2px; right: 0; z-index: 99"
                  />
                </template>

                <small class="text-danger">
                  {{ errors[0] }}
                </small>
              </ValidationProvider>
            </b-form-group>
          </b-col>

          <b-col
            xl="2"
            sm="6"
            class="py-1"
          >
            <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              variant="warning"
              class="btn-icon"
              @click="validationNewBookList(newBookkeep)"
            >
              <feather-icon icon="PlusIcon" />
            </b-button>
          </b-col>
        </b-row>
      </ValidationObserver>

      <div
        v-else-if="enabled"
        class="py-1"
      >
        <b-button
          variant="outline-primary"
          size="sm"
          class="d-inline-flex align-items-center"
          @click="showEmptyForm = true"
        >
          <feather-icon
            icon="PlusIcon"
            class="mr-25"
          />
          {{ $t('SettingPageCard.empty.addFirstCriteria') }}
        </b-button>
      </div>
    </template>
  </div>
</template>

<script>
import { settingsUtilsMixins } from '@/mixins/settingsUtilsMixins'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { required } from '@validations'

export default {
  name: 'Bookkeep',
  components: {
    ValidationProvider,
    ValidationObserver,
  },
  mixins: [settingsUtilsMixins],
  props: {
    textHelper: Array,
    hideWhenEmpty: { type: Boolean, default: false },
    enabled: { type: Boolean, default: true },
  },

  data() {
    return {
      bookKeppList: [],
      bookKeepListCopy: [],
      bookKeppParamsList: [],
      loadingState: true,
      showEmptyForm: false,
      newBookkeep: {
        criteriaValue: '',
        comparisonValue: '',
        criteria_value: '',
        comparison: '',
      },
      limit: 15,
      required,
    }
  },
  async mounted() {
    this.getBookKeeplist()
  },

  methods: {
    getBookKeeplist() {
      this.$useJwt
        .getBookKeepList()
        .then(res => {
          const results = res && res.data && Array.isArray(res.data.results)
            ? res.data.results
            : []
          const bookeep = []
          const bookeepCopy = []

          results.forEach(element => {
            bookeep.push({
              ...element,
              criteriaValue: this.renderCriteria(element.criteria_field),
              comparisonValue: this.renderComparison(element.comparison),
              comparisonError: false,
            })
            bookeepCopy.push({
              ...element,
              criteriaValue: this.renderCriteria(element.criteria_field),
              comparisonValue: this.renderComparison(element.comparison),
            })
          })

          this.bookKeppList = bookeep
          this.bookKeepListCopy = bookeepCopy
        })
        .catch(() => {
          this.bookKeppList = []
          this.bookKeepListCopy = []
        })
        .finally(() => {
          this.loadingState = false
        })
    },

    addNewBookkeep(value) {
      if (this.bookKeppList.length >= this.limit) {
        // limitMessage
        this.popup(
          this.$t('SettingPageCard.limitMessage', {
            number: this.limit,
          }),
          'danger',
          this.$t('Message.Error'),
          'AlertTriangleIcon',
        )
      } else {
        let newObject = ''

        if (this.bookKeppList.length > 0) {
          newObject = {
            ...value,
            criteria_field: value.criteriaValue.value,
          }
          this.bookKeppList.push(newObject)
        } else {
          newObject = {
            ...value,
            criteria_field: value.criteriaValue.value,
            comparison: value.comparisonValue.value,
          }
        }

        this.$useJwt.addBookKeepList(newObject).then(res => {
          const { data } = res
          this.popup(
            data[this.messageLang],
            'success',
            this.$t('Message.Success'),
            'CheckIcon',
          )
          this.getBookKeeplist()
        })
      }
    },
    removeBookeep(index, uuid) {
      this.$useJwt.deleteBookKeepList(uuid).then(res => {
        const { data } = res

        this.popup(
          data[this.messageLang],
          'success',
          this.$t('Message.Success'),
          'CheckIcon',
        )

        this.bookKeppList.splice(index, 1)

        if (this.bookKeppList.length == 0) {
          this.newBookkeep = {
            criteriaValue: '',
            comparisonValue: '',
            criteria_value: '',
            comparison: '',
          }
        }
      })
    },
    validationComparison(params, value) {
      const comparisonList = this.comparisonList(value.criteriaValue)

      const checkComparisonAvailable = comparisonList.find(
        element => element.value == value.comparisonValue.value,
      )

      if (checkComparisonAvailable == undefined) {
        value.comparisonValue = comparisonList[0]
        if (this.bookKeppList.length > 0) this.editBookeep(params, value)
      } else if (this.bookKeppList.length > 0) this.editBookeep(params, value)
    },
    editBookeep(params, value) {
      const newValue = {
        ...value,
        criteria_field: value.criteriaValue.value,
        comparison: value.comparisonValue.value,
      }

      if (this.bookKeppParamsList.length == 0) {
        this.bookKeppParamsList.push(newValue)
        this.$emit('bookeep', this.bookKeppParamsList)
      } else {
        const getUuid = this.bookKeppParamsList.find(
          element => element.uuid == value.uuid,
        )
        if (getUuid == undefined) {
          this.bookKeppParamsList.push(newValue)
          this.$emit('bookeep', this.bookKeppParamsList)
        } else {
          getUuid[params] = newValue[params]
          this.$emit('bookeep', this.bookKeppParamsList)
        }
      }
    },
    validationNewBookList(value) {
      this.$refs.form.validate().then(res => {
        if (res) this.addNewBookkeep(value)
      })
    },
  },
}
</script>

<style scoped lang="scss">
.per-page-selector-send-method {
  width: 320px;
}

.per-page-selector-criteria {
  width: 100%;
}
.per-page-selector {
  width: 100%;
}

.invoice-filter-select {
  min-width: 190px;

  ::v-deep .vs__selected-options {
    flex-wrap: nowrap;
  }

  ::v-deep .vs__selected {
    width: 100px;
  }
}
</style>
